export interface CandidateWriteFailureNotification {
  id: string;
  message: string;
  contactEmail: string;
  mailtoHref: string;
}

export function useCandidateWriteFailureNotification() {
  const notification = useState<CandidateWriteFailureNotification | null>(
    "candidate-write-failure-notification",
    () => null,
  );

  function publish(value: CandidateWriteFailureNotification) {
    notification.value = value;
  }

  function dismiss() {
    notification.value = null;
  }

  return {
    notification: readonly(notification),
    publish,
    dismiss,
  };
}
